// Packages
import { Component } from "react";

// Assets
import upArrow from "../../assets/images/up-arrow.png";

class ContactUs extends Component {
  render() {
    return (
      <div className="margin-auto">
        <section className="contact-section">
          <div className="row">
            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
              <div className="grid">
                <div className="row mt-40">
                  <div className="col-4 col-sm-4 col-md-4 col-lg-4">
                    <img src={upArrow} alt="Video"></img>
                    <label className="ml-2 fs-20 bold">
                      Upload In Progress
                    </label>
                  </div>
                  <div className="col-3 col-sm-3 col-md-3 col-lg-3 text-right">
                    <label className="fs-18 semi-bold dblack cp">
                      <u>Cancel Upload</u>
                    </label>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-8 col-md-8 col-lg-8">
                  <div className="uploadDocuments-card">
                    <div className="row">
                      <div className="col-6 col-sm-6 col-md-6 col-lg-6">
                        <div className="ml-2 bold fs-18 "></div>
                      </div>
                      <div className="col-6 col-sm-6 col-md-6 col-lg-6 text-right">
                        <button className="semi-bold greybtn">
                          Upload another angle
                        </button>
                      </div>
                    </div>
                    <div className="clear20"></div>
                    <div className="row"></div>
                    <div className="clear40"></div>
                  </div>
                </div>
                <div className=" col-sm-4 col-md-4 col-lg-4">
                  <div className="uploadDocuments-card">
                    <div className="row">
                      <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="row">
                          <div className="col-6">
                            <label className="ml-2 medium fs-16 fmlabel">
                              Select Event
                            </label>
                          </div>
                          <div className="col-6 text-right"></div>
                        </div>
                        <select className="form-control bold" placeholder="">
                          <option disabled selected>
                            Select
                          </option>
                          <option className="link-blue">+Add New Event</option>
                          <option></option>
                        </select>
                      </div>
                    </div>
                    <div className="clear30"></div>
                    <div className="row">
                      <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                        <label className="ml-2 medium fs-16 fmlabel">
                          Category
                        </label>
                        <br></br>
                      </div>
                    </div>
                    <div className="clear30"></div>
                    <div className="row">
                      <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                        <label className="ml-2 medium fs-16 fmlabel">
                          Playlist Name
                        </label>
                        <input
                          className="form-control medium"
                          placeholder="Enter playlist name"
                        ></input>
                      </div>
                    </div>
                    <div className="clear30"></div>
                    <div className="row">
                      <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                        <button className="saveBtn fs-16 mr-2">Save</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default ContactUs;
